import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { errMsg, http } from "@/lib/api";

const TOP = ["name", "email", "phone", "message"];

export const LeadForm = ({ type, fields, submitLabel = "Submit", successText = "Thank you! We'll be in touch." }) => {
  const [v, setV] = useState({});
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const body = { type, details: {} };
    Object.entries(v).forEach(([k, val]) => (TOP.includes(k) ? (body[k] = val) : (body.details[k] = String(val))));
    try {
      await http.post("/submissions", body);
      setDone(true);
      toast.success(successText);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (done)
    return (
      <div className="border-2 border-mas-olive bg-[#E8EBDD] p-8 text-center" data-testid={`${type}-success`}>
        <CheckCircle2 className="w-10 h-10 mx-auto text-mas-olive" />
        <p className="font-serif text-2xl font-bold mt-3">{successText}</p>
        <button onClick={() => { setDone(false); setV({}); }} className="mt-4 text-sm underline text-mas-mute" data-testid={`${type}-submit-another`}>Submit another</button>
      </div>
    );

  return (
    <form onSubmit={submit} className="grid sm:grid-cols-2 gap-4" data-testid={`${type}-form`}>
      {fields.map((f) => {
        const common = {
          required: f.required, value: v[f.name] || "", placeholder: f.placeholder || "",
          onChange: (e) => setV({ ...v, [f.name]: e.target.value }), className: "field",
          "data-testid": `${type}-${f.name}-input`,
        };
        return (
          <label key={f.name} className={`block ${f.full || f.type === "textarea" ? "sm:col-span-2" : ""}`}>
            <span className="text-xs font-semibold uppercase tracking-wider text-mas-mute">{f.label}{f.required && " *"}</span>
            <div className="mt-1.5">
              {f.type === "textarea" ? <textarea rows={4} {...common} /> : f.type === "select" ? (
                <select {...common}>
                  <option value="">Select...</option>
                  {f.options.map((o) => <option key={o} value={o}>{o}</option>)}
                </select>
              ) : <input type={f.type || "text"} {...common} />}
            </div>
          </label>
        );
      })}
      <div className="sm:col-span-2">
        <button disabled={busy} className="btn-terra w-full sm:w-auto" data-testid={`${type}-submit-button`}>{busy ? "Sending..." : submitLabel}</button>
      </div>
    </form>
  );
};
